import styles from './index.module.scss'
import { Button, message, Modal, Spin, Tooltip, } from 'antd';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';

const SelectBtnGroups = (props) => {
    const [isSelected, setIsSelected] = useState(false)
    const { selectedList, setSelectedList, isSelectedAll, downLoading } = props

    useEffect(() => {
        props.getIsSelected(isSelected)
    }, [isSelected])

    return (
        <div className={styles.SelectBtnGroups}>
            {!isSelected && <Button onClick={() => setIsSelected(true)}>批量操作</Button>}
            {isSelected &&
                <>
                    <Button onClick={props.selectAll}>{isSelectedAll ? '取消全选' : '全选'}</Button>
                    <Button disabled={selectedList.length == 0} loading={downLoading} onClick={props.downClick}>下载</Button>
                    <Button disabled={selectedList.length == 0} style={{color: selectedList.length != 0 && '#FF3B30'}} onClick={props.deleteClick} >删除</Button>
                    <Button
                        style={{ background: '#edf0ff' }}
                        onClick={() => {
                            setIsSelected(false);
                            setSelectedList([])
                        }}
                    >取消</Button>
                </>
            }
        </div>
    )
}


export default SelectBtnGroups
